module.exports = __webpack_public_path__ + "static/media/logLogo2.cdb88826.jpg";